import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Helmet from 'react-helmet';
import 'assets/scss/style.scss';
import LocaleProvider from './containers/LocaleContext';
import { EnterPaymentDetails } from 'screens/EnterPaymentDetails';
import { PageNotFound } from 'screens/PageNotFound';
import { LastRouter } from 'screens/LastRouter';
import { Success } from 'screens/Success';
import { ReceiptNotFound } from 'screens/ReceiptNotFound';
import { QueryClientProvider, QueryClient } from 'react-query';
const ComponentWithTitle = (title, Component) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null, title)),
        React.createElement(Component, null)));
};
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
const Root = () => (React.createElement(QueryClientProvider, { client: queryClient },
    React.createElement(LocaleProvider, null,
        React.createElement(Routes, null,
            React.createElement(Route, { path: "/:localeWithCountryCode", element: React.createElement(LastRouter, null) }),
            React.createElement(Route, { path: "/", element: ComponentWithTitle('Enter payment details', EnterPaymentDetails) }),
            React.createElement(Route, { path: "/success", element: ComponentWithTitle('Success', Success) }),
            React.createElement(Route, { path: "/error", element: ComponentWithTitle('Error', ReceiptNotFound) }),
            React.createElement(Route, { path: "*", element: ComponentWithTitle('Not Found', PageNotFound) }),
            React.createElement(Route, { path: "/page-not-found", element: ComponentWithTitle('Not Found', PageNotFound) })))));
export default Root;
